import { useGoogleMap } from '@ubilabs/google-maps-react-hooks';
import _ from 'lodash';
import { useEffect } from 'react';

import { useClinics } from '../../hooks/useClinics';
import { sortedClinicsWithDistance } from '../../store/selectors';
import { useLocatorStore } from '../../store/useLocatorStore';

export function useHandleNoResults() {
  const map = useGoogleMap();
  const { clinics } = useClinics();
  const currentLocation = useLocatorStore((state) => state.currentLocation);
  const visibleClinics = useLocatorStore((state) => state.visibleClinics);
  const clinicsWithDistance = useLocatorStore((state) => sortedClinicsWithDistance(state, clinics));
  const shouldGeoLocate = useLocatorStore((state) => state.shouldGeoLocate);
  const setVisibleClinics = useLocatorStore((state) => state.setVisibleClinics);
  const radius = useLocatorStore((state) => state.radius);

  const setClosestClinic = useLocatorStore((state) => state.setClosestClinic);
  const setIsUserZooming = useLocatorStore((state) => state.setIsUserZooming);
  const setActiveClinic = useLocatorStore((state) => state.setActiveClinic);

  useEffect(() => {
    if (currentLocation && !visibleClinics.length && radius !== undefined && map) {
      const sortedClinics = _.sortBy(clinicsWithDistance, 'distanceInMetres');

      const closestClinic = sortedClinics[0];

      const newBounds = new google.maps.LatLngBounds();

      newBounds.extend({
        lat: sortedClinics[0].Geolocation__c.latitude,
        lng: sortedClinics[0].Geolocation__c.longitude,
      });
      newBounds.extend(currentLocation);
      setClosestClinic(closestClinic);
      setVisibleClinics([closestClinic]);

      setActiveClinic(closestClinic);

      setIsUserZooming(false);
      map?.fitBounds(newBounds, 150);
      setTimeout(() => {
        setIsUserZooming(true);
      }, 1500);
    }
  }, [currentLocation, visibleClinics, radius]);

  useEffect(() => {
    setClosestClinic(undefined);
  }, [currentLocation, radius, shouldGeoLocate]);
}
